import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'

import Layout from './../components/Layout'
import ContentBlock from './../components/ContentBlock'
import SEO from './../components/Seo'

import { FontLight, FontRegular, Colors, Breakpoints, Sizes } from './../utils/variables'

export const Title = styled.h1`
    width: 100%;

    margin: 0 auto;
    padding: 110px 30px 15px;

    ${FontLight}
    font-size: 18px;
    line-height: 25px;

    color: ${Colors.blue};

    text-align: left;
    text-transform: uppercase;

    @media screen and (min-width: ${Breakpoints.wide}) {
        max-width: ${Sizes.maxContentWidth};

        padding: 180px 0 15px 0;
        
        ${FontRegular}
        font-size: 30px;
        line-height: 40px;
    }
`

export const Date = styled.div`
    display: block;

    width: 100%;

    margin: 0 auto 30px auto;
    padding: 0 30px;

    ${FontRegular}
	font-size: 10px;
	line-height: 1em;
	letter-spacing: 1px;
	
	color: ${Colors.black};
	opacity: 0.5;

	text-transform: uppercase;

	@media screen and (min-width: ${Breakpoints.wide}) {
        max-width: ${Sizes.maxContentWidth};

        margin: 0 auto 50px auto;
        padding: 0;

		font-size: 13px;
		letter-spacing: 2px;
	}
`

const NewsItem = props => {

    const content = props.data.prismicNews.data;
    
    return (
        <Layout theme='dark'>

            <SEO title={content.title.text} description={content.seo_description.text} />

            <Title>{content.title.text}</Title>
            <Date>Published: {content.date}</Date>

            <ContentBlock data={content.content.html} />
            
        </Layout>
    )

};

export default NewsItem;

export const pageQuery = graphql`
    query($uid: String) {
        prismicNews(uid: { eq: $uid }) {
            id
            uid
            data {
                title {
                    text
                    html
                }
                date(formatString: "DD/MM/YYYY")
                seo_description {
                    text
                }
                content {
                    html
                }
            }
        }
    }
`;